export const USER_EXPERIMENT_SEGMENTS_REQUEST = 'USER_EXPERIMENT_SEGMENTS_REQUEST';
export const USER_EXPERIMENT_SEGMENTS_SUCCESS = 'USER_EXPERIMENT_SEGMENTS_SUCCESS';
export const USER_EXPERIMENT_SEGMENTS_FAILURE = 'USER_EXPERIMENT_SEGMENTS_FAILURE';
